import { useTranslation } from "react-i18next";

const ContainerCard = ({ container }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-2xl shadow-mainShadow">
      <img
        className="h-[300px] w-full object-cover"
        src={container.img}
        alt={container.name}
      />
      <div className="p-5 space-y-4">
        <h2 className="text-2xl font-bold text-mainRed">{container.name}</h2>
        <p className="flex items-center justify-between">
          <span className="font-medium text-mainGray">{t("internalMeasurement")}</span>
          <span>{container.internal}</span>
        </p>
        {container.outer ? (
          <p className="flex items-center justify-between">
            <span className="font-medium text-mainGray">{t("outerMeasurement")}</span>
            <span>{container.outer}</span>
          </p>
        ) : null}
        <p className="flex items-center justify-between">
          <span className="font-medium text-mainGray">{t("doorMeasurement")}</span>
          <span>{container.doorMeasurement}</span>
        </p>
        {container.roofOpen ? (
          <p className="flex items-center justify-between">
            <span className="font-medium text-mainGray">
              {t("roofOpeningMeasurement")}
            </span>
            <span>{container.roofOpen}</span>
          </p>
        ) : null}

        <p className="flex items-center justify-between">
          <span className="font-medium text-mainGray">{t("loadingCapacity")}</span>
          <span>{container.loadingCapacity}</span>
        </p>
        <p className="flex items-center justify-between">
          <span className="font-medium text-mainGray">{t("emptyWeight")}</span>
          <span>{container.emptyWeight}</span>
        </p>
        <p className="flex items-center justify-between">
          <span className="font-medium text-mainGray">{t("maxLoadCapacity")}</span>
          <span>{container.maxLoad}</span>
        </p>
      </div>
    </div>
  );
};

export default ContainerCard;
